class ThemeToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    console.log('ThemeToggle initialized', this.button);
    this.init();
  }

  init() {
    // Check for saved theme preference or default to dark mode
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    console.log('Theme initialization:', { savedTheme, prefersDark });
    console.log('Current body classes:', document.body.className);
    
    // Set initial theme
    if (savedTheme === 'light' || (!savedTheme && !prefersDark)) {
      document.body.classList.add('light-mode');
      console.log('Set to light mode');
    } else {
      console.log('Staying in dark mode');
    }

    console.log('Body classes after init:', document.body.className);

    // Add click event listener
    if (this.button) {
      this.button.addEventListener('click', () => this.toggleTheme());
      console.log('Click listener added to button');
    } else {
      console.error('Theme toggle button not found!');
    }

    // Listen for system theme changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!localStorage.getItem('theme')) {
        if (e.matches) {
          document.body.classList.remove('light-mode');
        } else {
          document.body.classList.add('light-mode');
        }
      }
    });
  }

  toggleTheme() {
    const isLightMode = document.body.classList.contains('light-mode');
    
    console.log('=== TOGGLE THEME ===');
    console.log('Current light mode:', isLightMode);
    console.log('Body classes before toggle:', document.body.className);
    
    if (isLightMode) {
      document.body.classList.remove('light-mode');
      localStorage.setItem('theme', 'dark');
      console.log('Switched to dark mode');
    } else {
      document.body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
      console.log('Switched to light mode');
    }

    console.log('Body classes after toggle:', document.body.className);
    console.log('Body background color:', getComputedStyle(document.body).backgroundColor);
    console.log('Body color:', getComputedStyle(document.body).color);

    // Dispatch custom event for other components that might need to know
    document.dispatchEvent(new CustomEvent('themeChanged', {
      detail: { theme: isLightMode ? 'dark' : 'light' }
    }));
  }
}

customElements.define('theme-toggle', ThemeToggle);
